import React from 'react';
import clsx from 'clsx';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import { IProps } from './BreadCrumbBlock.interface';
import '@/blocks/BreadCrumbBlock/BreadCrumbBlock.styles.css';
import Icon from '@/elements/Icon/Icon.component';

// Utility to truncate text to 25 chars, adding ellipsis if needed
const truncate = (str: string, max = 25) =>
    str.length > max ? str.slice(0, max - 1) + '…' : str;


const BreadCrumbBlock: React.FC<IProps> = ({
    items,
    className,
    ...blockWrapperProps
}) => {
    if (!items || items.length === 0) return null;

    return (
        <BlockWrapper
            className={clsx('breadCrumbBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn>
                    <nav className="breadCrumbBlock__nav" aria-label="Breadcrumb">
                        <ol className="breadCrumbBlock__list" role="list">
                            <li className="breadCrumbBlock__item">
                                <a
                                    href={'/'}
                                    aria-label={'Home'}
                                    className="breadCrumbBlock__link breadCrumbBlock__link--home"
                                >
                                    <Icon icon="house" className="breadCrumbBlock__icon" />
                                </a>
                            </li>
                            {items.map((item, idx) => {
                                const isLast = idx === items.length - 1;
                                return (
                                    <li className="breadCrumbBlock__item" key={`breadcrumb-item-${idx}`}>
                                            <Icon
                                                icon="chevron-right"
                                                className="breadCrumbBlock__icon--chevron breadCrumbBlock__icon"
                                                aria-hidden="true"
                                            />
                                        {isLast ? (
                                            <span
                                                className="breadCrumbBlock__current"
                                                aria-current="page"
                                                tabIndex={0}
                                            >
                                                {truncate(item.text)}
                                            </span>
                                        ) : (
                                                <a
                                                    href={item.url}
                                                    aria-label={item.ariaLabel || truncate(item.text)}
                                                    className="breadCrumbBlock__link"
                                                >
                                                    {truncate(item.text)}
                                                </a>
                                        )
                                        }
                                    </li>
                                );
                            })}
                        </ol>
                    </nav>
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { BreadCrumbBlock };
